const NOOP = function() {};
const env = process.env;
let nrEmitter;
if (!process.browser && env.NEW_RELIC_APP_NAME && env.NEW_RELIC_LICENSE_KEY) {
    const newRelic = require('newrelic');
    const EventEmitter = require('events');
    nrEmitter = new EventEmitter();
    // newRelicEmitter.on(UNFULFILLED_PROMISE_EVENT, (err) => {
    //     newRelic.noticeError(err);
    // });
} else {
    nrEmitter = {emit: NOOP };
}

export const UNFULFILLED_PROMISE_EVENT = 'unfulfilledPromise';
export { nrEmitter as newRelicEmitter };



// WEBPACK FOOTER //
// ./app/lib/metrics/newRelicEventBus.js